const getDateRange = require("../components/dumb/IntervalFilterCustom/utils/getDateRange");
const param = require("mn-utils/param");
const formatTime = require("mn-utils/formatTime");

module.exports = (filter, sort, report, key) => {
  const dateMask = '{yyyy}-{mm}-{dd}';

  const {
    from,
    to,
    interval,
    search,
    ...rest
  } = filter;

  let dateFrom, dateTo;

  if (interval) {
    const dates = getDateRange(filter);

    dateFrom = dates.from;
    dateTo = dates.to;
  } else {
    dateFrom = from;
    dateTo = to;
  }

  const additionalData = report.additionalData || {};

  const formatTimeForParams = (date) => Math.floor(new Date(date).getTime() * 0.001);

  const params = {
    search: search || null,
    from: dateFrom && formatTimeForParams(dateFrom),
    to: dateTo && formatTimeForParams(dateTo),
    // from: dateFrom,
    // to: dateTo,
    ...rest,
    ...additionalData
  };

  if (sort['name']) {
    params['order_by'] = sort['name'];
    params['order_kind'] = sort['type'];
  }

  const queryString = param(params);

  const url = report.url + key + (queryString ? ('?' + queryString) : '');
  const name = report.prefix
    + (dateFrom ? '_' + formatTime(dateFrom, dateMask) : '')
    + (dateTo ? '_' + formatTime(dateTo, dateMask) : '')
    + '.' + key;

  return new Promise((resolve, reject) => {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {

          const link = document.createElement('a');
          link.download = name;
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          resolve();
        }
        reader.onerror = err => reject(err)
      })
      .catch(err => reject(err))
  });
}
